import { signal } from '@preact/signals';
import { ComponentChildren } from 'preact';
import { MenuChoice, selectedStyle } from './core';
import { Button } from '@components/buttons';
import { IcoDotsHorizontal } from '@components/icons';

const MAX_COLORS = 5;
const palette = signal(loadPalette());

function loadPalette(): string[] {
  const result = ['#f1f5f9', '#0d9488', '#0284c7', '#7c3aed'];
  try {
    return JSON.parse(localStorage['pageBuilder.palette'] || 'null') || result;
  } catch (err) {
    console.error(err);
    return result;
  }
}

export function ColorOptions(props: {
  label?: ComponentChildren;
  name: string;
  onChange(value: string | undefined): void;
  value: string | undefined;
}) {
  const colors =
    !props.value || palette.value.includes(props.value)
      ? palette.value
      : [...palette.value, props.value];

  const addColor = (color: string) => {
    if (!color) {
      return;
    }
    const newPalette = palette.value.filter((x) => x !== color);
    newPalette.push(color);
    palette.value = newPalette.slice(-MAX_COLORS);
    props.onChange(color);
  };

  return (
    <MenuChoice
      label={props.label || 'Color'}
      choices={colors}
      name={props.name}
      value={props.value}
      onChange={addColor}
      choiceUi={(color) => {
        return (
          <span
            class="flex size-4 grow bg-current focus:ring-2 ring-offset-2 ring-current items-center justify-center text-sm leading-0 outline-none cursor-pointer rounded-sm"
            style={{ color }}
          ></span>
        );
      }}
    >
      <Button
        onClick={() => props.onChange(undefined)}
        class={`border-2 shrink-0 font-medium ring-current inline-flex items-center justify-center leading-0 outline-none cursor-pointer hover:bg-gray-100 p-1 px-2 text-xs ${!props.value ? selectedStyle : 'text-gray-600 border-l-transparent ring-offset-2'}`}
      >
        Unset
      </Button>
      <label
        title="Color picker"
        class="aspect-square border-2 shrink-0 focus:ring-2 ring-offset-2 ring-current inline-flex items-center justify-center text-sm leading-0 outline-none cursor-pointer hover:bg-gray-100 border-l-transparent p-1 px-2 rounded-r-md"
      >
        <IcoDotsHorizontal />
        <input
          type="color"
          class="opacity-0 size-1 absolute"
          value={colors[0]}
          onInput={(e: any) => addColor(e.target.value)}
        />
      </label>
    </MenuChoice>
  );
}
